module.exports = __webpack_public_path__ + "img/error.9e80562.svg";